var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSm3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_77731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.6172 16.75C83.3444 16.75 83.9375 17.3405 83.9375 18.0674L83.9336 52.3789L83.9268 52.4658C83.926 52.4712 83.9244 52.4757 83.9238 52.4795C83.9244 52.4835 83.9259 52.4882 83.9268 52.4941C83.9298 52.5148 83.9336 52.5455 83.9336 52.5811V68.4043H98.9404L98.9551 68.4062H98.957C99.6717 68.4208 100.25 69.0049 100.25 69.7227V86.9326C100.25 87.6595 99.6569 88.25 98.9297 88.25H1.07031C0.343128 88.25 -0.25 87.6595 -0.25 86.9326V69.7227C-0.25 68.9958 0.343115 68.4053 1.07031 68.4053L16.0537 68.4082V52.5859C16.0537 51.8591 16.6468 51.2686 17.374 51.2686H32.3652V35.1729C32.3652 34.4461 32.9584 33.8555 33.6855 33.8555H48.6768V18.0674C48.6768 17.3407 49.27 16.7502 49.9971 16.75H82.6172ZM83.0234 71.0352C82.8991 71.077 82.7618 71.1054 82.6172 71.1055H67.625V85.6152H97.6045V71.0352H83.0234ZM35.0059 85.6152H64.9883V71.1055H35.0059V85.6152ZM2.38574 85.6152H32.3652V71.1055H17.373C17.2268 71.1054 17.0922 71.0764 16.9678 71.0352H2.38574V85.6152ZM51.3135 68.4043H81.2969V53.8945H51.3135V68.4043ZM18.6973 68.4082H48.6797V53.8984H18.6973V68.4082ZM67.625 51.0664H81.2969V36.5947H67.625V51.0664ZM35.0059 51.0654H64.9883V36.5938H49.9971C49.8091 36.5938 49.6403 36.5496 49.4883 36.4854H35.0059V51.0654ZM51.3174 33.8555H81.2998V19.3838H51.3174V33.8555Z",
    fill: "#C49A6C",
    stroke: "#C49A6C",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_77731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm3);
export default __webpack_public_path__ + "static/media/SM3.d22314060665c59dfd189e0c33d799b8.svg";
export { ForwardRef as ReactComponent };